import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm.773-5h-1.54V9.72h1.54V17zm0-8.33h-1.54V7.13h1.54v1.54z" }));
export default createSvgIcon(iconPath, "Info");
//# sourceMappingURL=InfoIcon.js.map